/**
 * Blood sabre (fx 'blood'): a dark red arc and blood spraying off the foe, or the caster's own blood
 * boiling for the frenzy.
 */
import { registerFx } from './registry';

registerFx('blood', (host) => ({
  skill: ({ src, tgt, s, style, sx, sy, tx, ty }) => {
    if (s.kind === 'buff') {
      host.fx.push({ type: 'pillar', x: sx, y: sy, t: 0, life: 0.9, col: '200,20,30' });
      host.fx.push({ type: 'ring', x: sx, y: sy, t: 0, life: 0.5, r: 26, col: '220,30,40' });
      host.bloodSpray(sx, sy - 20, 24, 60);
      host.sfx.swing();
      return;
    }
    host.swingArc(src, style, '200,30,40', 1.2);
    host.swingArc(src, style, '255,190,190', 0.8);
    if (s.aoe) {
      host.swingArc(src, 'spin', '170,10,20', 1.3);
      host.fx.push({ type: 'ring', x: sx, y: sy, t: 0, life: 0.5, r: s.aoe * 22, col: '200,20,30' });
      host.bloodSpray(sx, sy - 14, 30, 90);
    }
    if (tgt) host.bloodSpray(tx, ty - 14 * host.tall(tgt), 16, 70);
    host.sfx.swing();
  },
}));
